import { AssemblyKeywords } from 'components/ProjectPage/BillOfMaterials/Rows/Assembly/AssemblyKeywords/AssemblyKeywords'
import { AddWorkingStepButton } from 'components/ProjectPage/BillOfMaterials/Rows/Components/RowWorkingSteps/WorkingSteps/BomWorkingStepsList'
import { AssemblyHeaderMenuButton } from 'features/BillOfMaterials/BoMItemMenu/AssemblyHeaderMenuButton'
import { BomItemName } from 'features/BillOfMaterials/components/BomItemName'
import {
  BomItemPricePerBatch,
  useBomItemPricePerBatchStyles,
} from 'features/BillOfMaterials/components/BomItemPricePerBatch'
import { BomItemQuantity } from 'features/BillOfMaterials/components/BomItemQuantity'
import { RowThumbnailButton } from 'features/BillOfMaterials/components/BomItemThumbnailButton'
import { BomItemTotal } from 'features/BillOfMaterials/components/BomItemTotal'
import { BomItemTotalPrice } from 'features/BillOfMaterials/components/BomItemTotalPrice'
import { CommentTooltip } from 'features/BillOfMaterials/components/CommentForm/CommentTooltip'
import { BomItemRoutingData } from 'features/BillOfMaterials/RoutingHeader/RoutingData'
import { BoMItemType } from 'model/Project/BoMItemRow'
import { useBomItemDetailsDrawerStyles } from '../BomItemDetailsDrawer.styles'
import { BomItemTargetPriceInput } from '../Inputs/BomItemTargetPriceInput'
import { BomItemPriceContainer } from './BomItemPriceContainer'
import { BomItemDetailsProps } from './ProjectDetails/ProjectDetails'

export const AssemblyDetails = (props: BomItemDetailsProps) => {
  const sharedClasses = useBomItemDetailsDrawerStyles()
  const priceClasses = useBomItemPricePerBatchStyles({ fullWidth: false })

  return (
    <>
      <div className={sharedClasses.bomItemDescription}>
        <RowThumbnailButton
          bomItemType={props.bomItemType}
          rowId={props.bomItemId}
          size="large"
          pictureClassName={sharedClasses.picture}
        />
        <div className={sharedClasses.description}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <BomItemName
              bomItemId={props.bomItemId}
              label
              valueLabelProps={{
                label: '',
                valueProps: {
                  variant: 'h6',
                },
              }}
            />
            <CommentTooltip
              bomItemId={props.bomItemId}
              bomItemType={props.bomItemType}
            />

            <AssemblyHeaderMenuButton bomItemId={props.bomItemId} />
          </div>
          <div className={sharedClasses.prices}>
            <BomItemTargetPriceInput
              bomItemId={props.bomItemId}
              priceScope={'perUnit'}
              textFieldProps={{
                className: priceClasses.moneyTextField,
                inputProps: {
                  style: {
                    textAlign: 'right',
                    width: '90px',
                  },
                },
              }}
            />
            <BomItemQuantity
              bomItemId={props.bomItemId}
              translationKey={
                props.bomItemType === BoMItemType.row
                  ? 'common:quantity'
                  : 'project:batch-size'
              }
            />
            <BomItemTotal bomItemId={props.bomItemId} />
            <BomItemPricePerBatch
              bomItemId={props.bomItemId}
              valueLabelProps={{
                isLeftAligned: true,
              }}
            />
            <BomItemTotalPrice bomItemId={props.bomItemId} />
          </div>
        </div>
      </div>

      <div className={sharedClasses.unitSelector}>
        <AssemblyKeywords assemblyId={props.bomItemId} active={true} />
      </div>
      <div className={sharedClasses.unitSelector}>
        <AddWorkingStepButton
          bomItemType={BoMItemType.assembly}
          rowIds={[props.bomItemId]}
        />
        <BomItemRoutingData
          bomItemId={props.bomItemId}
          rootClassName={sharedClasses.workingSteps}
        />
      </div>
      <BomItemPriceContainer
        bomItemId={props.bomItemId}
        bomItemType={props.bomItemType}
      />
      {/* <div className={sharedClasses.bottomBar}>
        <BomItemWorkingStepSummary
          bomItemId={props.bomItemId}
          includeAssemblyWorkingSteps
          includeCountOfWorkingSteps
          shouldFilter
          ulClassName={classes.workingStepsSummary}
          size="large"
        />
      </div> */}
    </>
  )
}
